import React from "react";
import Skeleton from "react-loading-skeleton";

const HomeCarpetLoader = (count: any) => {

    return (
        <ul className="gallery_list prof w-list-unstyled">
            {Array(9)
                .fill(0)
                .map((item, index) => (
                    <li className="gallery_list_item prof" key={index}>
                        <Skeleton
                            height={"100%"}
                            style={{ zIndex: 0, lineHeight: 2 }}
                        />
                    </li>
                ))}
        </ul>
    )
}

export default HomeCarpetLoader;